import { render, staticRenderFns } from "./OfferPackages.vue?vue&type=template&id=36a9cd5e&scoped=true&"
import script from "./OfferPackages.vue?vue&type=script&lang=js&"
export * from "./OfferPackages.vue?vue&type=script&lang=js&"
import style0 from "./OfferPackages.vue?vue&type=style&index=0&id=36a9cd5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a9cd5e",
  null
  
)

export default component.exports